export default "__VITE_ASSET__DgAlSjno__"